var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRightNavigation = function SvgRightNavigation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#005098",
    d: "M.921.916a1.404 1.404 0 0 0 0 2.006L6.022 8.03l-5.1 5.037a1.41 1.41 0 0 0 .014 2.02c.576.554 1.47.554 2.031-.015l6.11-6.032a1.417 1.417 0 0 0 .014-2.006l-.014-.014L2.967.916a1.466 1.466 0 0 0-2.046 0"
  })));
};
export default SvgRightNavigation;